<template>
  <div class="content">
    <div class="container-fluid h-100">
      <card-item>
        <div class="d-flex justify-content-end">
          <a :href="link" class="btn btn-danger btn-sm"> Volver</a>
          <!-- <button class="btn btn-danger btn-sm"
          @click="volver"

          >Volver</button> -->
        </div>
      </card-item>
      <div class="row h-100">
        <div class="col h-100">
          <card-item
            class="striped-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Historial de {{ nombreCliente }}</h4>
                  <p class="card-category">Listado</p>
                </div>
              </div>
            </template>

            <div class="container-fluid h-100">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="quickFilter" class="label">Filtro rapido</label>
                    <input
                      type="text"
                      class="form-control"
                      id="quickFilter"
                      v-model="quickFilter"
                    />
                  </div>
                </div>
              </div>
              <div class="row" style="height: 100%">
                <div class="col" style="position: relative; height: 100%">
                  <ag-grid-vue
                    style="width: 100%; height: 60vh"
                    class="ag-theme-alpine"
                    :rowData="rowData"
                    :gridOptions="gridOptions"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    @grid-ready="onGridReady"
                    :getRowStyle="getRowStyle"
                    :getContextMenuItems="getContextMenuItems"
                  >
                  </ag-grid-vue>
                </div>
              </div>
            </div>
          </card-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "lodash-es";
import NombreCliente from "../../../Clientes/shared/NombreCliente";
import PeriodoComponent from "./Historial/PeriodoComponent";
import { AgGridVue } from "ag-grid-vue";
import maximaFechaDeCompromisoComponent from "./Historial/maximaFechaDeCompromisoComponent.vue";
import HistorialTableActions from "./Historial/HistorialTableActions.vue";
import axios from "axios";
import ReferenciaDeColoresHistorial from "./Historial/ReferenciaDeColoresHistorial.vue";
import moment from "moment";

export default {
  name: "HistorialDeTickets",
  components: {
    AgGridVue,
    //eslint-disable-next-line
    ReferenciaDeColoresHistorial,
  },
  mixins: [NombreCliente],

  data: () => ({
    quickFilter: "",

    // clienteId: null,
    gridApi: null,
    gridColumnApi: null,
    gridOptions: {
      statusBar: {
        statusPanels: [
          {
            statusPanel: "agTotalAndFilteredRowCountComponent",
            align: "left",
          },
          {
            statusPanel: "agTotalRowCountComponent",
            align: "center",
          },
          { statusPanel: "ReferenciaDeColoresHistorial", align: "right" },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" },
        ],
      },
      enableClipboard: true,
      enableRangeSelection: true,
      suppressCopyRowsToClipboard: false,
    },
    rowData: [],
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 250,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    },
    columnDefs: [
      {
        headerName: "Periodo",
        cellRendererFramework: PeriodoComponent,
        getQuickFilterText: (params) => `${params.data.periodo}`,
        sort: "desc",
        comparator: (valueA, valueB, nodeA, nodeB) => {
          const A = get(nodeA, "data.periodo", null);
          const B = get(nodeB, "data.periodo", null);
          return new Date(A) - new Date(B);
        },
        minWidth: 120,
        maxWidth: 130,
      },
      {
        headerName: "Motivo",
        field: "descripcion",
        wrapText: true,
        autoHeight: true,
      },
      {
        headerName: "Fecha de Compromiso",
        cellRendererFramework: maximaFechaDeCompromisoComponent,
        getQuickFilterText: (params) =>
          params.data.maximaFechaDeCompromiso
            ? `${params.data.maximaFechaDeCompromiso}`
            : "-",
        maxWidth: 200,
      },
      {
        headerName: "Comentarios",
        field: "comentarios",
        autoHeight: true,
        wrapText: true,
      },
      {
        headerName: "Resuelto",
        cellRenderer: (params) => {
          if (params.data.resuelto_fecha) {
            const fechaFormat = moment(params.data.resuelto_fecha).format(
              "ddd DD/MM/YYYY",
            );
            return fechaFormat;
          }
        },
        maxWidth: 150,
      },
      {
        cellRendererFramework: HistorialTableActions,
        flex: 2,
        headerName: "Acciones",
        maxWidth: 130,
      },
    ],
  }),
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
    link() {
      return `/#/admin/suspensiones/${this.modo}`;
    },
  },
  methods: {
    getContextMenuItems() {
      return ["copy", "excelExport"];
    },
    getRowStyle(params) {
      if (params.data.resuelto_fecha) {
        return {
          backgroundColor: "rgb(208,255,194)",
        };
      }
    },
    async onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.gridApi.showLoadingOverlay();

      this.clienteId = this.$route.params.id_cliente;

      const prom1 = this.getNombreCliente(this.clienteId);
      const prom2 = this.getData();

      await Promise.allSettled([prom1, prom2]);

      this.gridApi.hideOverlay();
    },
    async getData() {
      try {
        const resp = await axios.post("/execute", {
          method: "CLI.GetHistorialDeClienteByPeriodo",
          parameters: [{ name: "id_cliente", value: this.clienteId }],
        });
        if (get(resp, "data.ok", false)) {
          this.rowData = get(resp, "data.result[0]");
        }

        return resp.data;
      } catch (e) {
        console.log(e);
      }
    },
  },
  watch: {
    quickFilter(val) {
      if (this.gridApi) {
        this.gridApi.setQuickFilter(val);
      }
    },
  },
};
</script>

<style></style>
